import { render, staticRenderFns } from "./TaxInvoiceTph.vue?vue&type=template&id=56d30be4&scoped=true&"
import script from "./TaxInvoiceTph.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceTph.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=56d30be4&scoped=true&lang=css&"
import style1 from "./TaxInvoiceTph.vue?vue&type=style&index=1&id=56d30be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d30be4",
  null
  
)

export default component.exports